import React from 'react';

function StateComplete() {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 9.26758C0 4.29702 4.02944 0.267578 9 0.267578C13.9706 0.267578 18 4.29702 18 9.26758C18 14.2381 13.9706 18.2676 9 18.2676C4.02944 18.2676 0 14.2381 0 9.26758Z"
        fill="#0A8EA0"
      />
      <path
        d="M13.1311 5.28906L7.2001 11.2201L4.8691 8.89806L3.6001 10.1671L7.2001 13.7671L14.4001 6.56706L13.1311 5.28906Z"
        fill="white"
      />
    </svg>
  );
}

export default StateComplete;
